const EXTRA_PROPERTIES_KEY = 'extraProperties';
export const getExtraPropertiesKey = (args) => args ? [EXTRA_PROPERTIES_KEY, args] : [EXTRA_PROPERTIES_KEY];
//# sourceMappingURL=properties.keys.js.map